const contactForm =  () => ({
    formData: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        message: ''
    },
    init() {

    }
})

export default contactForm

window.addEventListener("alpine:init", ()=>{
  Alpine.data("contact_form", contactForm)
})